import browser from '@openclassrooms/utils/browser';

import handleUniversalSearch from './handleUniversalSearch';

const resetHeaderMenuClassnames = () => {
  // For now we need to remove manually menu classnames in the body
  browser.document.body.classList.remove('apprenticeship', 'employers');
};

export default function onRouteChange() {
  resetHeaderMenuClassnames();
  handleUniversalSearch();
}
